import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { X } from "@phosphor-icons/react";

import Icon from "components/Icon/Icon";
import Button from "components/Buttons";
import LoadingSpinner from "components/PageLoader/Spinner";
import { useCreatorUsersSlice } from "../slice";
import { getReviewAction } from "../slice/selectors";
import { UserActivateModalStyles } from "pages/Users/Modals/UserActivateModal/styled";
import { BrandFollowersWrapperModal } from "./styled";

const LowFollowerReviewModal = ({
  show,
  onHide,
  rowData,
  type,
  onActionSuccess
}) => {
  const dispatch = useDispatch();
  const { actions } = useCreatorUsersSlice();
  const { loading, success, error } = useSelector(getReviewAction);
  const secret_code = process.env.REACT_APP_SECRET_CODE;

  const isSubmittingRef = useRef(false);
  const isPending = rowData?.low_follower_review_status === "pending_approval";

  useEffect(() => {
    if (!isSubmittingRef.current) return;
    if (success || error) {
      isSubmittingRef.current = false;
      if (success) {
        dispatch(actions.resetReviewAction());
        onActionSuccess?.();
        onHide();
      }
    }
  }, [success, error]);

  const handleHide = () => {
    dispatch(actions.resetReviewAction());
    onHide();
  };

  const reviewData = useMemo(() => {
    try {
      return JSON.parse(rowData?.low_follower_review_data || "[]");
    } catch (e) {
      return [];
    }
  }, [rowData]);

  return (
    <BrandFollowersWrapperModal
      show={show}
      onHide={onHide}
      className="sidebar-modal"
      backdrop
      keyboard
      unmountOnExit
    >
      <Modal.Header>
        <Modal.Title>Review Creator</Modal.Title>
        <div onClick={handleHide} className="close-icon-wrapper">
          <Icon component={X} size={24} />
        </div>
      </Modal.Header>

      <Modal.Body>
        {reviewData.length > 0 && (
          <ul className="brand-list">
            {reviewData.map((item, index) => (
              <li key={index} className="brand-item">
                <div className="brand-name">
                  <strong>Brand Name:</strong> {item.brand_name}
                </div>
                <div className="brand-name">
                  <strong>Brand Link:</strong>{" "}
                  <div className="link-wrapper">
                    <a href={item?.video_link} target="_blank" rel="noreferrer">
                      {item?.video_link}
                    </a>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}

        <div className="notes-wrapper">
          <h5>NOTE:</h5>
          <p>
            Approving this creator will mark their low follower review as
            approved.
          </p>
          <p>Rejecting will mark it as rejected. This can be changed later.</p>
        </div>
      </Modal.Body>

      <Modal.Footer className="footer-actions">
        <Button
          colorScheme="error"
          onClick={() => {
            isSubmittingRef.current = true;
            dispatch(
              actions.lowFollowerReviewActionRequest({
                creator_user_id: rowData?.creator_user_id,
                secret_code,
                action: "rejected"
              })
            );
          }}
          disabled={loading || !isPending}
        >
          Reject
        </Button>

        <Button
          variant="primary"
          onClick={() => {
            isSubmittingRef.current = true;
            dispatch(
              actions.lowFollowerReviewActionRequest({
                creator_user_id: rowData?.creator_user_id,
                secret_code,
                action: "approved"
              })
            );
          }}
          disabled={loading || !isPending}
        >
          {loading ? <LoadingSpinner size={16} color="#A5A5A5" /> : "Approve"}
        </Button>
      </Modal.Footer>
    </BrandFollowersWrapperModal>
  );
};

export default LowFollowerReviewModal;
